import { Button } from 'theme-ui'
import CloseIcon from '../../icons/Close'

export default function CloseButton({ onClick }) {
    return (
        <Button
            variant="secondary"
            target="_blank"
            onClick={onClick}
            sx={{
                width: [36, 36, 36],
                height: [36, 36, 36],
                borderRadius: 18,
                lineHeight: [36, 36, 36],
                cursor: 'pointer',
                px: [0, 0, 0],
                ml: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CloseIcon width={12} height={12} />
        </Button>
    )
}
